import clsx from 'clsx';
import { FC } from 'react';
import { KTIcon } from '../../../../../../_metronic/helpers';
import { useGetTelegramBind } from '../../../telegram-forum/api/telegram.queries';
import { usePublishPost } from '../../posts-modal/api/posts.mutations';
import { PostDto } from '../model';

/** Требования бэкенда к публикации — проверяем здесь, чтобы не ловить 422. */
const missingFields = (post: PostDto): string[] => {
	const missing: string[] = [];
	if (!post.name?.ru?.trim()) missing.push('название RU');
	if (!post.name?.en?.trim()) missing.push('название EN');
	if (!post.image_path) missing.push('обложка');
	return missing;
};

const postLabel = (post: PostDto): string =>
	post.name?.ru || post.name?.en || post.uuid;

/**
 * Публикация поста в Telegram прямо из списка — чтобы старые новости можно
 * было отправить, не заходя в редактор. Клик спрашивает подтверждение:
 * сообщение уходит в живую группу.
 */
export const PostPublishButton: FC<{ post: PostDto }> = ({ post }) => {
	const { data: bind } = useGetTelegramBind();
	const { mutate: publish, isLoading } = usePublishPost();

	const isBound = Boolean(bind?.bound);
	const missing = missingFields(post);
	const isPublished = Boolean(post.publication?.published);
	const isPending = post.publication?.status === 'pending';
	const isDisabled = !isBound || missing.length > 0 || isLoading || isPending;

	const title = !isBound
		? 'Telegram-группа не привязана'
		: missing.length > 0
		? `Для публикации не хватает: ${missing.join(', ')}`
		: isPending
		? 'Публикуется, подождите'
		: isPublished
		? 'Обновить сообщение в Telegram'
		: 'Опубликовать в Telegram';

	const handleClick = () => {
		const question = isPublished
			? `Обновить сообщение «${postLabel(post)}» в Telegram?`
			: `Опубликовать «${postLabel(post)}» в Telegram?`;
		if (!window.confirm(question)) return;
		publish(post.uuid);
	};

	return (
		<button
			type='button'
			className={clsx(
				'btn btn-icon btn-sm',
				isPublished
					? 'btn-bg-light btn-active-color-primary'
					: 'btn-light-primary'
			)}
			onClick={handleClick}
			disabled={isDisabled}
			title={title}
		>
			{isLoading ? (
				<span className='spinner-border spinner-border-sm' role='status' />
			) : (
				<KTIcon iconName='send' className='fs-3' />
			)}
		</button>
	);
};
